import { render, staticRenderFns } from "./updateCompany.vue?vue&type=template&id=07c3daff&scoped=true&"
import script from "./updateCompany.vue?vue&type=script&lang=ts&"
export * from "./updateCompany.vue?vue&type=script&lang=ts&"
import style0 from "./updateCompany.vue?vue&type=style&index=0&id=07c3daff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3daff",
  null
  
)

export default component.exports